import { z } from 'zod';

export function buildEnumCSV<T extends [string, ...string[]]>(
  schema: z.ZodEnum<T>,
  fallback = '',
) {
  return z.string().transform((val, ctx) => {
    if (val.trim() === '') {
      return fallback;
    }

    const parts = val.split(',').map((p) => p.trim());

    const allValid = parts.every((part) => {
      const result = schema.safeParse(part);
      if (!result.success) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `"${part}" is not a valid option. Expected: ${schema.options.join(', ')}`,
        });
        return false;
      }
      return true;
    });

    if (!allValid) {
      return z.NEVER;
    }

    return parts.join(',');
  });
}
